import type { NumberSliderFieldValue } from "@smartsuite/types";
import { handleNumberField } from "../../prefill/helpers";
import type { FieldRegistryConfig } from "../../types";
import { defaultToReviewString } from "../review/reviewString.helpers";
import { NumberSliderFieldControl } from "./NumberSliderFieldControl/NumberSliderFieldControl";

export const numberSlideFieldConfig: FieldRegistryConfig<NumberSliderFieldValue> = {
  icon: "number-slider",
  control: (props) => <NumberSliderFieldControl {...props} />,
  prefill: handleNumberField,
  toReviewString: defaultToReviewString,
};
